export class GetChartFromSessionStreamChunkState implements Store.State {
  public loading = false;
  public error = null;
  constructor(public content: string,public runid:string,public node:string,public name:string) {}
}

export class GetChartFromSessionChainStartState implements Store.State {
  public loading = false;
  public error = null;
  constructor(public name: string) {}
}

export class GetChartFromSessionToolStartState implements Store.State {
  public loading = false;
  public error = null;
  constructor(public name: string) {}
}

export class GetChartFromSessionModelEndState implements Store.State {
  public loading = false;
  public error = null;
   constructor(public name: string) {}
}

export class GetChartFromSessionToolEndState implements Store.State {
  public loading = false;
  public error = null;
   constructor(public name: string) {}
}

export class GetTokenErrorState implements Store.State {
  public loading = false;
  public error = null;
  constructor(public name: string,public message:string) {}
}

import { Store } from "../../@core/store/store";

export class GetChartLoadingState extends Store.AbstractLoadingState<any> { }
export class GetChartLoadingErrorState extends Store.AbstractErrorState<any> { }
export class GetChartLoadedState extends Store.AbstractIdealState<any> { }

export class GetChartHIstoryLoadingState extends Store.AbstractLoadingState<any> { }
export class GetChartHIstoryLoadingErrorState extends Store.AbstractErrorState<any> { }
export class GetChartHIstoryLoadedState extends Store.AbstractIdealState<any> { }

export class GetChartFromSessionLoadingState extends Store.AbstractLoadingState<any> { }
export class GetChartFromSessionLoadingErrorState extends Store.AbstractErrorState<any> { }
export class GetChartFromSessionLoadedState extends Store.AbstractIdealState<any> { }

export class TextSpeakLoadingState extends Store.AbstractLoadingState<any> { }
export class TextSpeakLoadingErrorState extends Store.AbstractErrorState<any> { }
export class TextSpeakLoadedState extends Store.AbstractIdealState<any> { }

export class PromptSpeakLoadingState extends Store.AbstractLoadingState<any> { }
export class PromptSpeakLoadingErrorState extends Store.AbstractErrorState<any> { }
export class PromptSpeakLoadedState extends Store.AbstractIdealState<any> { }

export class OpenAttendanceCalendarState implements Store.State {
  public loading = false;
  public error = null;
  constructor(public data: any) { }
}